document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hero-swiper").forEach(function (el) {
    var slideCount = el.querySelectorAll(".swiper-slide").length;

    // Bei nur einem Slide keinen Swiper initialisieren.
    // Swiper mit loop:true und 1 Slide berechnet die Slide-Breiten beim
    // Resize falsch und kollabiert den Container.
    if (slideCount < 2) {
      el.classList.add("hero-swiper--single");
      return;
    }

    if (typeof Swiper === "undefined") return;

    new Swiper(el, {
      loop: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      watchOverflow: true,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
    });
  });
});
